/** Currency is fixed in V1: Tunisian dinar with 3 decimals (CMP-04). */
export const CURRENCY = { code: 'TND', decimals: 3 } as const;

/** PRC-01: a TVA rate is a percentage with at most two decimals (19, 13, 7, 0). */
export const TAX_RATE_MAX = 100;

/**
 * CD-10: the system price lists. Retail is the base list (the products' selling price).
 * Wholesale (SP-11) has no fallback: an item without a wholesale price has none.
 */
export const PRICE_LIST_KEYS = ['retail', 'online', 'wholesale'] as const;
export type PriceListKey = (typeof PRICE_LIST_KEYS)[number];

/** SP-11: whether a list falls back to the selling price where an item has no price on it. */
export const fallsBackOf = (systemKey: PriceListKey | null | undefined) =>
  systemKey !== 'wholesale';

/** Costing method is fixed in V1 (D7, CFG-10). */
export const COSTING_METHOD = 'weighted_average' as const;

/** What happens when an operation would make stock negative (D1, CFG-06). */
export const NEGATIVE_STOCK_POLICIES = ['allow_with_confirmation', 'block'] as const;
export type NegativeStockPolicy = (typeof NEGATIVE_STOCK_POLICIES)[number];

export const DATE_FORMATS = ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD'] as const;
export type DateFormat = (typeof DATE_FORMATS)[number];

/**
 * Number formats, named by their thousands and decimal separators.
 *   comma_dot    48,215.300
 *   space_comma  48 215,300
 *   dot_comma    48.215,300
 *   space_dot    48 215.300
 */
export const NUMBER_FORMATS = ['comma_dot', 'space_comma', 'dot_comma', 'space_dot'] as const;
export type NumberFormat = (typeof NUMBER_FORMATS)[number];

export const NUMBER_SEPARATORS: Record<NumberFormat, { group: string; decimal: string }> = {
  comma_dot: { group: ',', decimal: '.' },
  space_comma: { group: '\u00a0', decimal: ',' },
  dot_comma: { group: '.', decimal: ',' },
  space_dot: { group: '\u00a0', decimal: '.' },
};

export const DEFAULT_TIMEZONE = 'Africa/Tunis';

export const ADJUSTMENT_DIRECTIONS = ['increase', 'decrease', 'both'] as const;
export type AdjustmentDirection = (typeof ADJUSTMENT_DIRECTIONS)[number];

/** Adjustment reasons used by automatic processes; they can be renamed but never removed. */
export const SYSTEM_ADJUSTMENT_REASONS = ['count_correction', 'transit_loss'] as const;
export type SystemAdjustmentReason = (typeof SYSTEM_ADJUSTMENT_REASONS)[number];

/** Unit decimal precision bounds (CFG-01). */
export const UNIT_MAX_DECIMALS = 3;
